import AxiosManager from "../_axiosManager";

export async function putMember({ userId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/user/${userId}`,
    body,
  );

  return res;
}
